module.exports = __webpack_public_path__ + "img/babu-hover.dbb36c52.png";